/* IZEZE product tabs — detail / reviews / inquiry / shipping */
(function () {
  function init() {
    document.querySelectorAll('.izeze-tabs').forEach(function (root) {
      if (root.dataset.izInit) return;
      root.dataset.izInit = '1';
      var btns = Array.prototype.slice.call(root.querySelectorAll('.izeze-tabs__btn'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.izeze-tabs__panel'));
      var navWrap = root.querySelector('.izeze-tabs__nav-wrap');

      function activate(name, scroll) {
        btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.tab === name); });
        panels.forEach(function (pn) { pn.classList.toggle('is-active', pn.dataset.panel === name); });
        if (scroll && navWrap && navWrap.getBoundingClientRect().top < 0) {
          navWrap.scrollIntoView({ behavior: 'smooth' });
        }
        // help review widgets (Loox) lay out when shown from a hidden tab
        if (name === 'reviews') {
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
            try { if (window.loox && window.loox.reload) window.loox.reload(); } catch (e) {}
          }, 60);
        }
      }
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () { activate(btn.dataset.tab, true); });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
